import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext({ content: {}, refresh: () => {}, ready: false });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(data || {});
    } catch {
      /* keep last */
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, refresh, ready }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}

// Convenience hook: returns a `t(key, fallback)` helper bound to current content.
export function useT() {
  const { content } = useContent();
  return (key, fallback = "") => {
    const v = content[key];
    return (typeof v === "string" && v.length > 0) ? v : fallback;
  };
}
